/**
 * Web shim for react-native-svg
 * Maps to standard SVG HTML elements.
 */

import React from 'react';

const createSvgElement = (tag: string) => {
  const Component: React.FC<any> = ({ children, ...props }) => {
    return React.createElement(tag, props, children);
  };
  Component.displayName = tag;
  return Component;
};

export const Svg = createSvgElement('svg');
export const Circle = createSvgElement('circle');
export const Ellipse = createSvgElement('ellipse');
export const G = createSvgElement('g');
export const Text = createSvgElement('text');
export const TSpan = createSvgElement('tspan');
export const TextPath = createSvgElement('textPath');
export const Path = createSvgElement('path');
export const Polygon = createSvgElement('polygon');
export const Polyline = createSvgElement('polyline');
export const Line = createSvgElement('line');
export const Rect = createSvgElement('rect');
export const Use = createSvgElement('use');
export const Image = createSvgElement('image');
export const Symbol = createSvgElement('symbol');
export const Defs = createSvgElement('defs');
export const LinearGradient = createSvgElement('linearGradient');
export const RadialGradient = createSvgElement('radialGradient');
export const Stop = createSvgElement('stop');
export const ClipPath = createSvgElement('clipPath');
export const Pattern = createSvgElement('pattern');
export const Mask = createSvgElement('mask');
export const ForeignObject = createSvgElement('foreignObject');

export default Svg;
